
import $            from 'jquery';
import constants    from 'Constants';
import utils        from 'util/Util'
import widgetUtil   from 'util/WidgetUtil'
import undoService from 'UndoService';
import { Model }    from 'backbone';
import BaseTableView from 'properties/BaseTableView'
import Template     from 'behaviors/properties/main/notify.ejs';
import eventBus from 'EventBus';
import editNotificationModal from 'behaviors/properties/main/notify/EditNotificationModalView';
import util         from 'util/Util';
import NotificationService from 'NotificationService';

//=====================================================================
//
// An instance of this view represents a Notify.
//
// Casey Justus, May 30, 2016
//
//=====================================================================

class MainNotifyView extends BaseTableView {

    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;    
        $(this.el).off('click');
        this.gridEl = constants.PROP_MAIN_TABLE_NOTIFY_BEHAVIOR_VIEW;

        this.events = {
            "click #editNotify"     : "editNotify"
        };

        //this.initModelValues();
        this.initGridValues();
        this.listenTo(this.model, 'change', this.render);

        if (!utils.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, utils.resizeGridWidth);
        }

        return this;
    }

    initGridValues() {
        const gridData = [];
        const data = this.model.get('notifications');

        // PF-4862 Refactored to eliminate extra rows and extra code.
        data && data.map( item => gridData.push( {'title': item.title, 'role': item.role} ) );

        this.model.set('gridData', gridData, {silent: true});
        util.setGridScrollPos(this.model);
    }

    editNotify(ev){
        util.saveGridScrollPos(this.model);
        ev.preventDefault();
        const factoryKey= 'modal';

        const sfModal = new editNotificationModal({model: new Model({data: this.model.get('notifications')})});
        sfModal.render().then((result)=>{
            const oldNotifications=this.model.get('notifications');
            const oldGridData=this.model.get('gridData');
            const oldWidgetText=this.model.get('widgetText');
            this.model.set('notifications', result,{silent:true});
            const gridData = [];

            // PF-4862 Refactored to eliminate extra rows and extra code.
            result.map( item => gridData.push( {'title': item.title, 'role': item.role} ) );

            this.model.set('gridData', gridData,{silent:true});
            this.model.set('widgetText', widgetUtil.getWidgetText(this.model) ,{silent:true}) ;
            this.model.trigger('widgetTextUpdated');
            this.model.trigger('loadRelatedFields');
            this.render();

            const updatedWidgetText=this.model.get('widgetText');

            undoService.add({
                undo:() => {
                    this.model.set('notifications',oldNotifications,{silent:true});
                    this.model.set('gridData',oldGridData,{silent:true});
                    this.model.set('widgetText',oldWidgetText,{silent:true});
                    this.model.trigger('widgetTextUpdated');
                    this.render();
                },
                redo:() => {
                    this.model.set('notifications',result,{silent:true});
                    this.model.set('gridData',gridData,{silent:true});
                    this.model.set('widgetText',updatedWidgetText,{silent:true});
                    this.model.trigger('widgetTextUpdated');
                    this.render();
                }
            },'Set Notifications')
        }).catch((err)=> {
            if(err.message !== constants.DIALOG_CANCELED){
                NotificationService.error('Error when updating Notify');
            }else{
                this.model.set('notifications',err.originalData,{silent:true});
            }
        });
    } 
}

export default MainNotifyView;
